module.exports = __webpack_public_path__ + "img/GAME_BALLOON1.f282c998.jpg";